import {
  CAMPAIGN_METRICS,
  REP_STACK_METRICS,
  REP_TREND_METRICS,
} from '../componentKeys.js'

const identifiers = {
  key: 'transfersPerMachineHour',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Transfer / Machine Hour',
  },
}

const keys = {
  componentKeys: [CAMPAIGN_METRICS, REP_STACK_METRICS, REP_TREND_METRICS],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'divide',
  dividend: { stat: 'transfer_complete' },
  divisor: { stat: 'machine_hours', convertTo: 'hours' },
}

const transfersPerMachineHour = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { transfersPerMachineHour }
